module.exports = __webpack_public_path__ + "static/media/london_5.d30e07c4.png";